import { fetchContentFragmentsFromCms, getLocale } from '@msc-b2c/shared-utils';
import {
  IFetchMainNotesFromFragmentsResponse,
  MainNotesFromFragmentsRequest,
  Note,
} from '@msc-b2c/interfaces/interfaces';

export async function fetchMainNotesContentFragment(
  departureDate: string | undefined,
  departurePort: string | undefined,
  shipCode: string,
  area: string | undefined,
  serviceType: (string | undefined)[] | undefined
) {
  let response = null;

  const body = {
    currentDate: departureDate ?? '',
    locale: getLocale() ?? '',
    departurePort: departurePort ?? '',
    shipCode: shipCode ?? '',
    cruiseArea: area ?? '',
    limit: 10,
    ...(serviceType?.length > 0 && {
      serviceType: {
        _logOp: 'OR',
        _expressions: serviceType?.map((type: string | undefined) => ({
          value: type,
          _operator: 'EQUALS',
        })),
      },
    }),
  };

  try {
    const result = await fetchContentFragmentsFromCms<
      IFetchMainNotesFromFragmentsResponse,
      MainNotesFromFragmentsRequest
    >('getMyAreaNotes', body);

    response = result?.data?.noteData?.items;
  } catch (error) {
    console.error('Error fetching main notes:', error);
  }
  return response;
}

/**
 * Sorts an array of notes based on their priority order.
 *
 * @param {Note[] | null} notes - An array of Note objects or null.
 * @returns {Note[]} - A sorted array of Note objects by priority order, or an empty array if notes is null.
 */
export function getSortedNotes(notes: Note[] | null) {
  return notes ? [...notes].sort((note1, note2) => note1.priorityOrder - note2.priorityOrder) : [];
}
